import List from "@/components/list";
/*
 *  超级管理员可以修改readony=1的数据，其他角色不可以，有新增权限才可以操作
 */

const Table = args => {
  const AccountTableConfig = [
    {
      label: "学习名称",
      prop: "lectureName",
      minWidth: "150",
    },{
      label: "学习时间",
      prop: "trainTimeStr",
      minWidth: "150",
    },{
      label: "学时",
      prop: "lectureHours",
      minWidth: "110",
    },{
      label: "学习单位",
      prop: "organizer",
      minWidth: "150",
    }
  ];

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
